export default "__VITE_ASSET__DDvOQDJc__"